import { Icon } from '@iconify/react'
import { TotpCodeField } from '@/components/TotpCodeField'
import styles from '../AuthLayout/AuthForm.module.css'

interface TwoFactorLoginStepProps {
  code: string
  onCodeChange: (value: string) => void
  onSubmit: () => void
  onBack: () => void
  isSubmitting: boolean
  errorMessage: string | null
}

export function TwoFactorLoginStep({
  code,
  onCodeChange,
  onSubmit,
  onBack,
  isSubmitting,
  errorMessage,
}: TwoFactorLoginStepProps) {
  return (
    <form
      className={styles.form}
      onSubmit={(event) => {
        event.preventDefault()
        onSubmit()
      }}
    >
      <TotpCodeField
        id="login-totp-code"
        value={code}
        onChange={onCodeChange}
        disabled={isSubmitting}
        autoFocus
      />

      {errorMessage && (
        <div className={styles.error} role="alert">
          {errorMessage}
        </div>
      )}

      <button
        type="submit"
        className={styles.submit}
        disabled={isSubmitting || code.length !== 6}
      >
        <Icon icon="mdi:shield-key" className={styles.submitIcon} />
        {isSubmitting ? 'Validando...' : 'Confirmar código'}
      </button>

      <button
        type="button"
        className={styles.backButton}
        onClick={onBack}
        disabled={isSubmitting}
      >
        Usar outra conta
      </button>
    </form>
  )
}
